import React from 'react';
import PropTypes from 'prop-types';

const PatientClass = ({ adt_class_description }) => (
	adt_class_description ? (
		<span> - {adt_class_description}</span>
	) : ' '
);
PatientClass.propTypes = {
	adt_class_description: PropTypes.string
};

export default PatientClass;
